export const buildSearchPath = (params) => `/search${params ? `/${params}` : ''}`;

export const buildDetailPath = (id, slug = '') => `/detale/${id}-${slug}`;
